import React from "react";
import "./Checkbox.css";

const Checkbox = ({ id, checked, onChange, label, disabled }) => {
  return (
    <div className="flex gap-1 items-center ">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />

      <label htmlFor={id} className="text-[#361A0A] font-[Biennale-Regular]">
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
